module.exports = __webpack_public_path__ + "img/hd.3bc7ac63.jpg";